module.exports = __webpack_public_path__ + "static/img/4.a748bf7b.png";